export const readStoredTokenValue = (storedValue: string | null | undefined): string => {
  const value = storedValue?.trim()
  if (!value) return ''

  try {
    const parsed = JSON.parse(value)
    if (typeof parsed === 'string') return parsed
    if (parsed === null || parsed === undefined) return ''

    return String(parsed)
  } catch {
    return value
  }
}

const getStoredValue = (storageKey: string) =>
  typeof window === 'undefined' ? '' : readStoredTokenValue(window.localStorage.getItem(storageKey))

const withAuthPrefix = (token: string, prefix: 'Basic' | 'Bearer') => {
  if (!token) return ''

  return token.toLowerCase().startsWith(`${prefix.toLowerCase()} `) ? token : `${prefix} ${token}`
}

export const getStoredApiKey = () => getStoredValue('NEXTROUND_API')

export const getApiAuthorizationHeader = (storedValue?: string | null) =>
  withAuthPrefix(
    storedValue === undefined ? getStoredApiKey() : readStoredTokenValue(storedValue),
    'Basic',
  )

export const getBearerAuthorizationHeader = (storedValue?: string | null) =>
  withAuthPrefix(
    storedValue === undefined ? getStoredValue('NEXTROUND_USER_TOKEN') : readStoredTokenValue(storedValue),
    'Bearer',
  )
